import { signalStore } from '@ngrx/signals';
import { withCartItem } from './features/withCartItem';
import { withCartItemPricing } from './features/withCartItemPricing';
import { SavedCartComponentStore } from '../cart/saved-cart.component.store';

export const SavedCartItemComponentStore = signalStore(
  withCartItem({
    cartStoreType: SavedCartComponentStore,
  }),
  withCartItemPricing(),
);
export type SavedCartItemComponentStore = InstanceType<typeof SavedCartItemComponentStore>;
